<div class="viewerNavWrapper">
  <div class="sr-only"
   aria-live="polite"
   aria-atomic="true">
    {{ navAnnouncement }}
  </div>

  <div class="viewer-nav-buttons">
    <div class="nav-page-numbers nav-page-numbers-mobile">
      <ng-container *ngTemplateOutlet="pageNumbers"></ng-container>
    </div>
    <div class="viewer-nav-button-container">
      <div class="viewer-nav-button">
        <zbp-button-component id="navPrevious"
                              type="button"
                              [label]="'back'"
                              [ariaLabel]="'back'"
                              [disabled]="!hasPrevious"
                              (click)="togglePrevious()"
                              [theme]="'darkBlue'"
                              [borderRadius]="'0 16px 0 0'"
                              [iconPosition]="'top'"
                              [iconName]="zbpIconNames.backArrow">
        </zbp-button-component>
      </div>
      <div class="viewer-control-separator viewer-control-separator-desktop-only"></div>  
      <div class="nav-page-numbers nav-page-numbers-desktop">
        <ng-container *ngTemplateOutlet="pageNumbers"></ng-container>
      </div>
      <div class="viewer-control-separator viewer-control-separator-desktop-only"></div>  
      <div class="viewer-nav-button">
        <zbp-button-component id="navNext"
                              type="button"
                              [label]="'Next'"
                              [ariaLabel]="'Next Material'"
                              [disabled]="!hasNext"
                              (click)="toggleNext()"
                              [theme]="'darkBlue'"
                              [borderRadius]="'0 0 16px 0'"
                              [iconPosition]="'top'"
                              [iconName]="zbpIconNames.arrow_right">
        </zbp-button-component>
      </div>
    </div>
   
  </div>
</div>

<ng-template #pageNumbers>
  <div>
    {{pageInfo?.page}}
  </div>
  <div>
    of
  </div>
  <div>
    {{pageInfo?.pages}}
  </div>
</ng-template>
